/**
 * Attach merge helper for path-keyed cache / WPML language navigation.
 *
 * @param {Window} global - Global object (`window`).
 */
(function (global) {
	/**
	 * Merge the browser address bar query string into a navigation URL.
	 *
	 * Path-keyed full-page cache may serve HTML built without the visitor's query
	 * params; `global.location.search` is the source of truth at runtime.
	 *
	 * For each key present in the current search string: removes that key from the
	 * target, then appends the current values (so address-bar params win; duplicate
	 * keys from the current URL are preserved in order).
	 *
	 * @param {string} targetUrl - Absolute or relative URL.
	 * @return {string} Resolved URL with merged query, or original on failure.
	 */
	function growtherapyWpmlMergeLocationSearchIntoUrl(targetUrl) {
		if (!targetUrl || typeof targetUrl !== 'string') {
			return targetUrl;
		}

		try {
			const target = new URL(targetUrl, global.location.origin);
			const currentParams = new URLSearchParams(global.location.search);

			if ([...currentParams.keys()].length === 0) {
				return target.href;
			}

			const keysToReplace = new Set(currentParams.keys());
			keysToReplace.forEach((key) => {
				target.searchParams.delete(key);
			});
			currentParams.forEach((value, key) => {
				target.searchParams.append(key, value);
			});

			return target.href;
		} catch {
			return targetUrl;
		}
	}

	global.growtherapyWpmlMergeLocationSearchIntoUrl =
		growtherapyWpmlMergeLocationSearchIntoUrl;
})(typeof window !== 'undefined' ? window : this);
